export default __webpack_public_path__ + "static/media/SCB_BTC.9d34d233.png";